module.exports = __webpack_public_path__ + "img/ciocan.4167e821.jpeg";